import { render, staticRenderFns } from "./form6.vue?vue&type=template&id=388d9160&scoped=true"
import script from "./form6.vue?vue&type=script&lang=js"
export * from "./form6.vue?vue&type=script&lang=js"
import style0 from "./form6.vue?vue&type=style&index=0&id=388d9160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d9160",
  null
  
)

export default component.exports